const {registerModule, KitModule} = window;

class Tab extends KitModule {
  constructor($element) {
    super($element);
    this.$activeTab = this.$element.querySelector('[aria-selected="true"]');
    this.$activeTabId = this.$activeTab.getAttribute('aria-controls');

    this.init();
  }

  init() {
    this.hideTabs();
    this.handleEvents();
  }

  /**
   * Add event listeners to all tab buttons
   */
  handleEvents() {
    this.$tabButtons.forEach(($tabButton) => {
      $tabButton.addEventListener('click', this);
    });
  }


  /**
   * Reset the current active tab
   * and set the new one
   * @param {HTMLElement} tab - The tab to update
   */
  updateActiveTab(tab) {
    this.$activeTab.setAttribute('aria-selected', false);
    this.$activeTab.classList.remove('is-active');

    this.$activeTab = tab;
    this.$activeTab.setAttribute('aria-selected', true);
    this.$activeTab.classList.add('is-active');
    this.$activeTabId = this.$activeTab.getAttribute('aria-controls');
  }

  /**
   * Hide all tabs except the active one
   */
  hideTabs() {
    Array.from(this.$tabItems).filter(($item) => {
      if (this.$activeTabId === $item.getAttribute('id')) {
        $item.classList.remove('is-visually-hidden');
      } else {
        $item.classList.add('is-visually-hidden');
      }
    });
  }

  /**
   * Handle the click event
   * @param {Event} event - The click event
   */
  onclick(event) {
    event.preventDefault();
    const $target = event.target;

    // If the target is already selected, do nothing
    if ($target.closest('[aria-selected="true"]')) {
      return;
    } else {
      this.updateActiveTab($target.parentNode);
      this.hideTabs();
    }
  }
}

registerModule('Tab', Tab);

